import React, { Component } from 'react';
import { APIHandler, DataHandler } from 'C4';

export default class AppSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appInfo: {},
    }
  }
  componentWillMount() {
    DataHandler.matchAppId().then((appId) => {
      APIHandler.getAppInfo(appId).then((res) => {
        // console.log(res);
        this.setState({ appInfo: res });
      });
    });
  }

  render() {
    return null;
  }
}

